import { PaymentMethod } from "../paymentMethod/tenantLicenceRequest";

export class PaymentSubscription {
  startDateTime: string | undefined;
  endDateTime: string | undefined;
  trialEndDateTime: string | undefined;
  state: PaymentSubscriptionState;
  discount: Discount;
  items: PaymentSubscriptionItem[];
  amountItems: PaymentSubscriptionAmountItem[];
  otherItems: PaymentSubscriptionOtherItem[];
  constructor(payload?: any) {
    if (payload) {
      this.state = payload?.state;
      this.startDateTime = payload?.startDateTime;
      this.endDateTime = payload?.endDateTime;
      this.trialEndDateTime = payload?.trialEndDateTime;
      if (payload.discount) {
        this.discount = new Discount(payload?.discount)
      }
      if (payload.items) {
        this.items = PaymentSubscriptionItem.createPaymentSubscriptionItem(payload?.items);
      }
      if (payload.amountItems) {
        this.amountItems = PaymentSubscriptionAmountItem.createPaymentSubscriptionAmountItem(payload?.amoutItems);
      }
      if (payload.otherItems) {
        this.otherItems = PaymentSubscriptionOtherItem.createPaymentSubscriptionOtherItem(payload?.amoutItems);
      }
    }
  }
  static getPayementType(paymentMethod: PaymentMethod): any{
    switch (paymentMethod?.type) {
      case 'card' : return 'Kreditkarte **** **** **** ' + paymentMethod?.details?.last4;
      case 'sepa_debit' : return 'SEPA-Lastschrift ** ** ******** ******' + paymentMethod?.details?.last4;
      default: 'Banküberweisung';
    }
    return "Rechnung";
  }
}

export class PaymentSubscriptionItem {
  type: LicenceTypeId
  quantity: string;
  assigned: string;
  price: string;
  currency: string;
  interval: string;
  discount: Discount
  constructor(payload?: any) {
    if (payload) {
      this.type = payload.type;
      this.quantity = payload.quantity;
      this.assigned = payload.assigned;
      this.price = payload?.price;
      this.currency = payload?.currency;
      this.interval = payload?.interval;
      if (payload.discount) {
        this.discount = new Discount(payload.discount)
      }
    }
  }
  /**
   * creates  from a result
   * @param result Array of any
   * @returns Array of Templates
   */
  static createPaymentSubscriptionItem(result: Array<any>): PaymentSubscriptionItem[] {
    const items = new Array<PaymentSubscriptionItem>();
    if (result) {
      result.map((item) => {
        items.push(new PaymentSubscriptionItem(item));
      });
    }
    return items;
  }
}

export class PaymentSubscriptionAmountItem {
  productName: string
  quantity: string;
  price: string;
  currency: string;
  interval: string;
  currentMaxAmount: number;
  totalAmountUsed: number;
  amountUnit: string;
  perUnitAmount: number;
  discount: Discount
  constructor(payload?: any) {
    if (payload) {
      this.productName = payload.productName;
      this.quantity = payload.quantity;
      this.price = payload?.price;
      this.currency = payload?.currency;
      this.interval = payload?.interval;
      this.currentMaxAmount = payload?.currentMaxAmount;
      this.totalAmountUsed = payload?.totalAmountUsed;
      this.amountUnit = payload?.amountUnit;
      this.perUnitAmount = payload?.perUnitAmount;
      if (payload.discount) {
        this.discount = new Discount(payload.discount)
      }
    }
  }
  /**
   * creates  from a result
   * @param result Array of any
   * @returns Array of Templates
   */
  static createPaymentSubscriptionAmountItem(result: Array<any>): PaymentSubscriptionAmountItem[] {
    const items = new Array<PaymentSubscriptionAmountItem>();
    if (result) {
      result.map((item) => {
        items.push(new PaymentSubscriptionAmountItem(item));
      });
    }
    return items;
  }
}

export class PaymentSubscriptionOtherItem {
    productName: string;
    quantity: string;
    price: string;
    totalPrice: string;
    currency: string;
    interval: string;
    discount: Discount;
    constructor(payload?: any) {
        if (payload) {
            this.productName = payload.productName;
            this.quantity = payload.quantity;
            this.price = payload?.price;
            this.totalPrice = payload?.totalPrice;
            this.currency = payload?.currency;
            this.interval = payload?.interval;
            if (payload.discount) {
                this.discount = new Discount(payload.discount)
            }
        }
    }
  static createPaymentSubscriptionOtherItem(result: Array<any>): PaymentSubscriptionOtherItem[] {
    const items = new Array<PaymentSubscriptionOtherItem>();
    if (result) {
      result.map((item) => {
        items.push(new PaymentSubscriptionOtherItem(item));
      });
    }
    return items;
  }
}

export class Discount {
  amountOff: string;
  duration: string;
  percentOff: string;
  currency: string;
  durationInMonths: string;
  name: string;
  constructor(payload?: any) {
    if (payload) {
      this.amountOff = payload.amountOff;
      this.duration = payload.duration;
      this.percentOff = payload.percentOff;
      this.durationInMonths = payload.durationInMonths;
      this.name = payload.name;
    }
  }
}

export  enum PaymentSubscriptionState {
  NO_PAYMENT, TRIAL, RUNNING
}

export class Invoice {
  number: string;
  date: string;
  amount: string;
  currency: string;
  downloadLink: string;
  state: string;
  constructor(payload?: any) {
    if (payload) {
      this.number = payload.number;
      this.date = payload.date;
      this.amount = payload.amount;
      this.currency = payload.currency;
      this.downloadLink = payload.downloadLink;
      this.state = payload?.state;
    }
  }
}

export interface LicenceType {
  id: string;
  name: string;
  roleName: LicenceTypeRoleName | undefined;
}

export enum LicenceTypeId {
  FULL_USER = 'FULL_USER',
  APP_USER = 'APP_USER',
  NO_LICENCE = 'NO_LICENCE'
}

export enum LicenceTypeRoleName {
  FULL_USER = 'framework_licencing_full_user',
  APP_USER = 'framework_licencing_app_user'
}

export function getLicenceTypes(): LicenceType[] {
  return [
    {
      id: LicenceTypeId.FULL_USER,
      name: 'Full User',
      roleName: LicenceTypeRoleName.FULL_USER
    },
    {
      id: LicenceTypeId.APP_USER,
      name: 'App User',
      roleName: LicenceTypeRoleName.APP_USER
    },
    {
      id: LicenceTypeId.NO_LICENCE,
      name: 'Keine Lizenz',
      roleName: undefined
    }
  ]
}

export class StorageInfo {
    totalAmountUsed: number
    amountUnit: string
    constructor(payload?: any) {
        this.totalAmountUsed = payload.totalAmountUsed;
        this.amountUnit = payload.amountUnit;
    }
}
